<template>
  <div v-if="!isPrint">
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <div>
      <h5 class="my-4"><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.inputA_1" />
        </div>
        <div>
          <div>소속명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_2" />
        </div>
        <div>
          <div>점검자</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputA_3"/>
        </div>
      </div>
    </div>

    <!-- 검사순서 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 검사순서</h5>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-x-6 gap-y-4 mt-4">
        <div v-for="(_title, _title_i) in getTitles" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">
          <div v-if="isPrint || board.readonly" class="flex items-center">
            <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title_i !== 0? `${_title_i}.` : ''}} {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox color="secondary" :disabled="_title_i === 0" v-model="form.inspectChecked" :vs-value="_title">{{ _title_i !== 0? `${_title_i}.` : ''}} {{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <TableInspectMerge
      v-for="(item, itemIndex) in form.inspectList"
      :key="`inspect_${item.title}`"
      v-show="form.inspectChecked.includes(item.title)"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="item.title"
      :tableHeaderTitle="item.tableHeaderTitle || '점검내용'"
      :table-header-note="[{ text: '비고', width: '320px' },]"
      :popup-title="itemIndex===0? '참고자료':null"
      contentBefore="•"
      v-model="item.list"
      class="mt-5"
    >
      <template v-slot:popup="{ title }">
        <div v-if="title === '참고자료'" >
          <vs-tabs v-if="isMobile" v-model="currentTab">
            <vs-tab v-for="(tab, index) in tabs" :key="index" :label="tab.label"
                    class="test"
                    @click="onTab(index)">
            </vs-tab>
          </vs-tabs>
          <vs-tabs v-else class="tabs-wrap-reverse" v-model="currentTab" style="width: 1045px">
            <vs-tab v-for="(tab, index) in tabs" :key="index" :label="tab.label"
                    class="test"
                    @click="onTab(index)">
            </vs-tab>
          </vs-tabs>

          <div class="p-2" style="overflow: auto;">
            <div class="text-center" style="height: 921px">
              <img class="h-full" :src="`/popup/${tabs[currentTab].image}_${currentPage}.png`" style="object-fit: cover;"/>
            </div>
          </div>
          <div v-if="totalPages > 1" style="display: flex; justify-content: center;" class="w-full">
            <pagination :current-page.sync="currentPage" :total-pages="totalPages" />
          </div>
        </div>

        <div v-else-if="title === '응축수 발생원인과 문제점 및 해결방안'">
          <img class="pb-2" src="/popup/응축수 발생원인과 문제점 및 해결방안.png" style="min-width: 566px;"/>
        </div>
      </template>
    </TableInspectMerge>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import CompanySelector from "@/components/selector/CompanySelector";

import inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Pagination from "@/components/Pagination.vue";
import Print from "./Print.vue";

export default {
  components: {
    Print,
    Pagination,
    NameWithSignatureRow,
    SignField,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    DateSelector,
    DisasterClassSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      showPopup: false,
      currentTab: 4,
      currentPage: 1,
      // [참고 1] 부터 [참고 4] 까지 하단에 위치 시키기 위해서 순서 변경 함
      tabs: [
        { label: '[참고 1] 산업안전보건기준에 관한 규칙(안전밸브의 설치 등)', image: '[참고 1] 산업안전보건기준에 관한 규칙(안전밸브의 설치 등)', totalPages: 5 },
        { label: '[참고 2] 규격 및 형식별 적용범위 (별표1)', image: '[참고 2] 규격 및 형식별 적용범위 (별표1)', totalPages: 3 },
        { label: '[참고 3] 안전밸브 설치위치', image: '[참고 3] 안전밸브 설치위치', totalPages: 4 },
        { label: '[참고 4] 압력용기 안전검사 고시', image: '[참고 4] 압력용기 안전검사 고시', totalPages: 3 },
        { label: '압력용기의 구조 및 검사 범위', image: '압력용기의 구조 및 검사 범위', totalPages: 1 },
        { label: '안전밸브의 분류 및 작동불능 주요 원인', image: '안전밸브의 분류 및 작동불능 주요 원인', totalPages: 1 },
      ],

      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        inspectChecked: ["압력용기 검사 시 주의사항"],
        inspectList: inspectData,

        photoList: [],
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    isMobile(val) {
      if (val) {
        this.tabs = [
          { label: '압력용기의 구조 및 검사 범위', image: '압력용기의 구조 및 검사 범위', totalPages: 1 },
          { label: '안전밸브의 분류 및 작동불능 주요 원인', image: '안전밸브의 분류 및 작동불능 주요 원인', totalPages: 1 },
          { label: '[참고 1] 산업안전보건기준에 관한 규칙(안전밸브의 설치 등)', image: '[참고 1] 산업안전보건기준에 관한 규칙(안전밸브의 설치 등)', totalPages: 5 },
          { label: '[참고 2] 규격 및 형식별 적용범위 (별표1)', image: '[참고 2] 규격 및 형식별 적용범위 (별표1)', totalPages: 3 },
          { label: '[참고 3] 안전밸브 설치위치', image: '[참고 3] 안전밸브 설치위치', totalPages: 4 },
          { label: '[참고 4] 압력용기 안전검사 고시', image: '[참고 4] 압력용기 안전검사 고시', totalPages: 3 },
        ]
      } else {
        this.tabs = [
          { label: '[참고 1] 산업안전보건기준에 관한 규칙(안전밸브의 설치 등)', image: '[참고 1] 산업안전보건기준에 관한 규칙(안전밸브의 설치 등)', totalPages: 5 },
          { label: '[참고 2] 규격 및 형식별 적용범위 (별표1)', image: '[참고 2] 규격 및 형식별 적용범위 (별표1)', totalPages: 3 },
          { label: '[참고 3] 안전밸브 설치위치', image: '[참고 3] 안전밸브 설치위치', totalPages: 4 },
          { label: '[참고 4] 압력용기 안전검사 고시', image: '[참고 4] 압력용기 안전검사 고시', totalPages: 3 },
          { label: '압력용기의 구조 및 검사 범위', image: '압력용기의 구조 및 검사 범위', totalPages: 1 },
          { label: '안전밸브의 분류 및 작동불능 주요 원인', image: '안전밸브의 분류 및 작동불능 주요 원인', totalPages: 1 },
        ]
      }
    },
  },
  computed: {
    getTitles() {
      return this.form.inspectList.map((item) => item.title);
    },
    totalPages() {
      return this.tabs[this.currentTab].totalPages;
    },
    isMobile () {
      return !(this.$store.state.verticalNavMenuWidth === 'default')
    },
  },
  methods: {
    onTab(index) {
      this.currentTab = index;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped lang="scss">
.infoBtn {
  display: inline-flex;
  column-gap: 7px;
  color: #7e72f2;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 8px;
}
</style>

<style lang="scss">
.tabs-wrap-reverse.vs-tabs-position-top {
  .vs-tabs--ul {
    flex-wrap: wrap-reverse;
  }
}
</style>
